import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    DialogContentText,
} from "@mui/material";

function CodeInputPopup({ open, onClose, onSubmit }) {
    const [code, setCode] = useState("");

    const handleSubmit = () => {
        if (code.trim()) {
            onSubmit(code);
            setCode("");
        }
    };

    return (
        <Dialog disableEscapeKeyDown open={open} onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                onClose();
            }
        }} PaperProps={{
            sx: {
                backgroundColor: "#ffffff", // custom background color
                borderRadius: 3,           // optional: rounded corners
                padding: 2,                // optional: extra padding
            },
        }}>
            <DialogContent>
                <DialogContentText style={{ fontFamily: "poppins", fontWeight: 500, fontSize: "17px", color: "#303030" }}  >Enter Verification Code</DialogContentText>

                <DialogContentText style={{ fontFamily: "poppins", fontWeight: 500, fontSize: "13px" }}  >Enter code you received from the event host.</DialogContentText>

                <TextField
                    autoFocus
                    margin="dense"
                    label="Code"
                    type="text"
                    fullWidth
                    inputMode={'numeric'}
                    variant={'filled'}
                    value={code}
                    sx={{
                        input: { color: "#303030", fontFamily: "poppins", fontWeight: 400, },

                        // label color
                        "& .MuiInputLabel-root": { color: "#aaaaaa" },
                        "& .MuiInputLabel-root.Mui-focused": { color: "#303030", fontFamily: "poppins" },

                        // stroke (border) color
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": { borderColor: "#aaaaaa30", borderWidth: "2px" },          // default
                            "&:hover fieldset": { borderColor: "#706dea" },   // on hover
                            "&.Mui-focused fieldset": { borderColor: "#706dea" }, // on focus
                        },
                    }}
                    onChange={(e) => setCode(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit} style={{ fontFamily: "poppins", fontWeight: 400, background: "#706dea" }} variant="contained">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CodeInputPopup;
